import styled from 'styled-components';

export const ContentInfoSubtitle = styled.div`
	margin-bottom: 20px;
	font-size: 22px;
	font-weight: bold;
	line-height: 1.2;

	.title {
		margin-right: 10px;
	}

	.data {
		color: #a197a1;
	}
`;
